// DeleteMessageAction.js
import React from 'react';
import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import axios from "axios";
import config from '../config';
import DeleteButton from '../components/DeleteButton';

export default function DeleteMessageAction(props) {
  const {
    as: Wrapper = 'div',
    messageIdx,
    conversationSID,
    onDeleted,
    disabled = false,
  } = props;
  
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const CHAT_DELETE_RESOURCE = `/chat/delete_chat_message/`;

  const handleConfirm = async () => {
    setBusy(true);
    // The backend derives the acting user from the auth token (the own-message
    // delete gate only trusts the authenticated caller), so send the token and
    // no longer pass a body user_id.
    const token = JSON.parse(window.localStorage.getItem('bootstrap'))?.token;
    const params = { message_idx: messageIdx, conversation_sid: conversationSID }
    const config_opts = { headers: { Authorization: `Token ${token}` } }
    await axios.post(`${config.apiUrl}${CHAT_DELETE_RESOURCE}`, params, config_opts).then(response => {
          console.debug(`DeleteMessageAction: ${CHAT_DELETE_RESOURCE} response: `, response)
          enqueueSnackbar('Message deleted', { variant: 'default' });

      }).catch((error) => {
          if (error.response) {
              console.error(`DeleteMessageAction: ${CHAT_DELETE_RESOURCE}: Error deleting message!`, error.response)
          }
          enqueueSnackbar('Error deleting message', { variant: 'error' });
      });
    setBusy(false);
    setOpen(false);
    if (onDeleted) {
      onDeleted(messageIdx);
    }
  };      

  return (
    <Wrapper>

      {/* CP-5545: the shared outlined red DELETE (it was a text button wrapping a second icon button). */}
      <DeleteButton size="small" onClick={() => setOpen(true)} disabled={disabled}>
        Delete message
      </DeleteButton>

      <Dialog open={open} onClose={() => !busy && setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Delete message?</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2">
            This will permanently remove the selected message. This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={busy}>Cancel</Button>
          <DeleteButton onClick={handleConfirm} disabled={busy}>
            {busy ? 'Deleting…' : 'Delete'}
          </DeleteButton>
        </DialogActions>
      </Dialog>
    </Wrapper>
  );
}
